import 'firebase/auth'
import 'firebase/firestore'
import { firebaseReducer } from 'react-redux-firebase'
// import { createFirestoreInstance, firestoreReducer } from 'redux-firestore' // <- needed if using firestore
import { routerMiddleware, routerReducer } from 'react-router-redux'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { firestoreReducer } from 'redux-firestore'
import thunkMiddleware from 'redux-thunk'

import championships from './modules/championships'
import deviceAuth from './modules/deviceAuth'
import notifications from './modules/notifications'
import settings from './modules/settings'
import tournaments from './modules/tournaments'

const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
  settings,
  notifications,
  deviceAuth,
  router: routerReducer,
  tournaments,
  championships,
} as any)

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
  }
}

// tslint:disable
const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose
// tslint:enable

const configureStore = (firebaseConfig, history) => {
  return createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(thunkMiddleware, routerMiddleware(history))),
  )
}

export default configureStore



// WEBPACK FOOTER //
// ./src/redux/configureStore.ts